import { ApplicationDebt } from "@ploy-lib/types";

// Keep in sync with redistribution logic in AggregateSplitLoanDataFlow.cs
function mapLoanType(d: ApplicationDebt): number {
	switch (d.loanType) {
		case "limit_loan":
			return 6;
		case "mortgage":
			return 5;
		case "student_loan":
			return 4;
		case "car_loan":
			return 3;
		case "unsecured_loan":
			return 2;
		case "credit_card":
			return 1;
		case "CustomerEngagement":
			return 0;
		default:
			return 10; // NotSet
	}
}

function debtComparer(a: ApplicationDebt, b: ApplicationDebt): number {
	const aLoanType = mapLoanType(a);
	const bLoanType = mapLoanType(b);

	if (aLoanType !== bLoanType) return aLoanType - bLoanType;

	return a.amount - b.amount;
}

// Please keep algorithm somewhat in sync with MapRefinancedApplicationDebtToPayment.cs
export function MapAndOrderRefinancedDebts(
	debts: ApplicationDebt[] = [],
	loanAmount: number = 0
): ApplicationDebt[] {
	if (loanAmount < 0) loanAmount = 0;

	let refinancedDebts = debts
		.map(debtToCopy => ({ ...debtToCopy }))
		.sort(debtComparer);

	for (const d of refinancedDebts) {
		if (d.refinance) {
			d.refinanceAmount = d.amount > loanAmount ? loanAmount : d.amount;
			loanAmount = loanAmount - d.refinanceAmount;
		}
	}

	return refinancedDebts;
}
